import { Button, Col, Form, Input, Modal, Result, Row, Select, theme } from 'antd'
import TextArea from 'antd/es/input/TextArea'
import React, { useCallback, useRef, useState } from 'react'
import API from 'API';
import { createFormData, toTitleCase } from 'general_function';
import { DownloadOutlined, GiftFilled, HeartFilled } from '@ant-design/icons';
import "./sendWeddingWish.css"
import QRCode from 'react-qr-code';
import BowTie from 'pages/ShowWeddingWishes/Icon/BowTie';
import Ring from 'pages/ShowWeddingWishes/Icon/Ring';
import Heart from 'pages/ShowWeddingWishes/Icon/Heart';
import Flower from 'pages/ShowWeddingWishes/Icon/Flower';
import { toPng } from 'html-to-image';

function WeddingGiftButton({ onClick }) {
    return <Button type='primary' style={{ width: "100%", backgroundColor: "#3F0115", color: "#fff3c2" }} onClick={onClick}>
        <GiftFilled /> Tặng quà cưới <GiftFilled />
    </Button>
}

export default function SendWeddingWish({ confirmJoin = false, invitation }) {
    // eslint-disable-next-line
    const [images, setImages] = useState([]);
    const { token } = theme.useToken();
    const [submitted, setSubmitted] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const { self_pronoun, customer_address_term, displayname } = invitation?.data || {
        self_pronoun: "chúng mình",
        customer_address_term: "bạn",
    }
    const [openGiftWedding, setOpenGiftWedding] = useState(false);
    const QRRef = useRef();

    const onFinish = useCallback((values) => {
        setSubmitting(true);
        const formData = createFormData(
            { ...values, image: images[0]?.originFileObj }
        )

        if (invitation) {
            formData.append("invitation_id", invitation.id);
        }

        API.post("send-wedding-wish/", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
            .then(res => {
                setSubmitted(true);
            })
            .catch(error => {

            })
            .finally(() => {
                setSubmitting(false);
            })
    }, [images, invitation])

    const onFinishFailed = useCallback(() => {

    }, [])

    const clickGiftButton = useCallback(() => {
        setOpenGiftWedding(true);
    }, [])

    const downloadQR = useCallback(async () => {
        if (!QRRef.current) return;

        const dataUrl = await toPng(QRRef.current, {
            cacheBust: true,
        });

        const link = document.createElement("a");
        link.download = "mung_cuoi_Dien_Trang.png";
        link.href = dataUrl;
        link.click();
    }, [])

    return <>{
        submitted ? <>
            <Result
                status="success"
                title="Lời chúc đã được gửi thành công"
                subTitle={`${toTitleCase(self_pronoun)} cảm ơn ${customer_address_term} rất nhiều 🤗`}
            />
            <div style={{ textAlign: "center" }}>
                <WeddingGiftButton onClick={clickGiftButton} />
            </div>
        </>
            : <div className='send-wedding-wish-form' id="send-wedding-wish">
                <div
                    className='primary-color'
                    style={{
                        fontFamily: "'Charm', cursive",
                        fontSize: "18px",
                        fontWeight: "500",
                        fontStyle: "italic",
                        textAlign: "center",
                        // margin: "50px 0px 30px"
                        padding: "50px 0px 30px"
                    }}>
                    Một lời chúc nhỏ, một kỷ niệm lớn
                </div>
                <Form
                    name='wedding-wish'
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    initialValues={{
                        name: displayname,
                    }}
                >
                    <Form.Item
                        name="message"
                        rules={[
                            { required: true, message: `Gửi lời chúc cho ${self_pronoun} nhé` }
                        ]}
                    >
                        <TextArea placeholder={`Gửi lời chúc cho ${self_pronoun.toLowerCase()} nhé`} style={{ height: 100 }} />
                    </Form.Item>
                    <Form.Item
                        name="name"
                        rules={[
                            { required: true, message: `${toTitleCase(customer_address_term)} ơi, nhớ nhập tên người chúc nhé` }
                        ]}
                    >
                        <Input placeholder='Người chúc' />
                    </Form.Item>
                    {/* <Form.Item>
                        <Divider>Một tấm ảnh đẹp kèm lời chúc</Divider>
                        <UploadImgs fileList={images} setFileList={setImages} onlyImage />
                    </Form.Item> */}
                    {confirmJoin && <Form.Item
                        name="confirm_join"
                        rules={[
                            { required: true, message: `${toTitleCase(customer_address_term)} ơi, ${customer_address_term} sẽ tham dự chứ ạ?` }
                        ]}
                    >
                        <Select options={[
                            { value: 1, label: "Sẽ tham dự" },
                            { value: 2, label: "Không tham dự được" },
                            { value: 3, label: "Đang cân nhắc" },
                        ]} placeholder={`${toTitleCase(customer_address_term)} sẽ tham dự chứ?`} />
                    </Form.Item>}
                    <Row gutter={8}>
                        <Col xs={24} sm={12} style={{ padding: 3 }}>
                            <Button
                                type='primary'
                                htmlType='submit'
                                style={{ width: "100%", color: "#fff3c2" }}
                                loading={submitting}
                            >
                                <HeartFilled /> Gửi lời chúc <HeartFilled />
                            </Button>
                        </Col>
                        <Col xs={24} sm={12} style={{ padding: 3 }}>
                            <WeddingGiftButton onClick={clickGiftButton} />
                        </Col>
                    </Row>
                </Form>
            </div>
    }
        <Modal
            classNames={{
                header: "wedding-gift-modal-header",
                container: "wedding-gift-modal-container",
            }}
            styles={{
                footer: {
                    margin: 0,
                }
            }}
            open={openGiftWedding}
            okText="Đóng"
            onCancel={() => setOpenGiftWedding(false)}
            footer={[
                <Button type='primary' onClick={() => setOpenGiftWedding(false)}>Đóng</Button>
            ]}
            title=" "
            forceRender
        >
            <div ref={QRRef} style={{ padding: 15, backgroundColor: "rgb(243, 237, 224)" }}>
                <div style={{ textAlign: "center" }}>
                    <div style={{ display: "inline-block", position: "relative" }}>
                        <div style={{ position: "absolute", top: -15, right: -20 }}>
                            <BowTie />
                        </div>
                        <div style={{ position: "absolute", top: -18, left: -18, transform: "rotate(-90deg)" }}>
                            <Ring />
                        </div>
                        <div style={{ position: "absolute", bottom: -5, left: -5 }}>
                            <Heart />
                        </div>
                        <div style={{ position: "absolute", bottom: -5, right: -20 }}>
                            <Flower />
                        </div>
                        <QRCode
                            value='00020101021138540010A00000072701240006970436011093498425980208QRIBFTTA53037045802VN63049A19'
                            bgColor="rgb(243, 237, 224)"
                            fgColor={token.colorPrimary}
                        />
                    </div>
                    <div>
                        <Button type='text' onClick={downloadQR} style={{ color: token.colorPrimary }}>
                            <DownloadOutlined /> Tải QR
                        </Button>
                    </div>
                </div>
                <ul>
                    <li><b>Ngân hàng:</b> Vietcombank</li>
                    <li><b>Chủ tài khoản:</b> NGUYEN HA TRANG</li>
                    <li><b>Số tài khoản:</b> 9349842598</li>
                </ul>
            </div>
        </Modal>
    </>
}
